/**
 * YouTube stream event parser
 */

/**
 * Parse YouTube stream event
 * @param {object} event - Raw YouTube event
 * @returns {object|null} Normalized event
 */
function parseYouTubeEvent(event) {
  if (!event || !event.type) return null;
  
  const type = event.type.toLowerCase();
  const platform = 'youtube';
  
  // Extract user info
  const user = {
    username: event.username || event.author || event.user?.username || 'Viewer',
    displayName: event.displayName || event.authorName || event.user?.displayName,
    imageUrl: event.imageUrl || event.authorPhoto || event.user?.imageUrl || null,
    userId: event.userId || event.authorChannelId || event.user?.id
  };
  
  // Common fields
  const base = {
    platform,
    user,
    id: event.id || event.messageId || `youtube_${Date.now()}_${Math.random()}`,
    timestamp: event.timestamp || Date.now()
  };
  
  switch (type) {
    case 'comment':
    case 'chat':
    case 'message':
      return {
        ...base,
        type: 'comment',
        message: event.comment || event.message || event.text || event.messageText || ''
      };
      
    case 'gift':
    case 'superchat':
    case 'super_chat':
      return {
        ...base,
        type: 'gift',
        giftName: event.giftName || event.superChatName || 'Super Chat',
        giftCount: 1,
        value: event.value || event.amount || 0,
        totalValue: event.value || event.amount || 0
      };
      
    default:
      return null;
  }
}

export { parseYouTubeEvent };
